<template>
  <VDialogBox
    ref="dialogRegion"
    :visible="visibleRegionBox"
    class="dialog-region"
    show-footer
    confirm-button-text="Done"
    cancel-button-text="Cancel"
    @update-action="onUpdateAction"
    @close="closeDialog"
  >
    <keep-alive>
      <SelectRegionBox
        v-if="visibleRegionBox"
        @checked="onChecked"
      />
    </keep-alive>
  </VDialogBox>
</template>

<script>
import { storeToRefs } from 'pinia'
import VDialogBox from 'fe-vui/dialogBox'
import { prefixLink } from '@ms/config/app'
import modalHelper from '@ms/utils/scroll-fixed'
import { useSettingStore } from '@ms/stores/setting.js'
import SelectRegionBox from './SelectRegionBox'
import { switchRegion } from './region.js'
import useSwitchRegion from './useStoreRegion'

export default {
  components: {
    VDialogBox,
    SelectRegionBox
  },
  props: {
    source: {
      type: String,
      default: ''
    },
    regionRedirectUrl: {
      type: String,
      default: ''
    }
  },
  setup() {
    const { ipRegion } = useSwitchRegion()

    const setting = useSettingStore()
    const { visibleRegionBox } = storeToRefs(setting)

    return {
      ipRegion,
      visibleRegionBox
    }
  },
  data() {
    return {
      visible: false,
      autochecked: false,
      checkedRegion: this.$region
    }
  },
  methods: {
    closeDialog() {
      modalHelper.beforeClose()
      useSettingStore().toggleRegionBox(false)
      this.autochecked = false
    },
    onUpdateAction(action) {
      if (action === 'confirm') {
        this.changeRegion(this.source)
      }
    },
    onChecked(region) {
      this.checkedRegion = region
    },
    changeRegion(source = '') {
      let redirectUrl = this.regionRedirectUrl
      const isDiscounts = /discounts\/\w{15,}\//.test(location.pathname)
      const isPagemaker = /promotion\/.*\.html/.test(location.pathname)
      const shouldRedirectHome = !redirectUrl && (isDiscounts || isPagemaker)
      if (shouldRedirectHome) {
        redirectUrl = prefixLink()
      }

      switchRegion({
        region: this.checkedRegion,
        source,
        auto: this.autochecked,
        redirectUrl
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-region {
  z-index: 10000;
}
</style>
